import React, { useState, useEffect, useContext } from "react";
import Card from "../../../components/Graph/Graphcard";

import {
  fetchcomplaintlt18Data,
  fetchcomplaintlt24Data,
  complaintDataTat,
  // CAC
  fetchComplaintltDataCAC,
  fetchcomplaintlt24hrsDataCAC,
  fetchComplaintDataTatCACC,
  // CSR
  fetchComplaintDataTatCSR,
  fetchComplaintltDataCSR,
  fetchComplaintlt24hrsDataCSR,
} from "./KpiGraph";
import { FilterContext } from "../../../context/Filter";

const Graphview = ({ initialLoad, setInitialLoad }) => {
  const [chartData, setChartData] = useState(null);
  const { open } = useContext(FilterContext);
  const [chartDatalt24, setChartlt24Data] = useState(null);
  const [chartDatalt48, setChartgt48Data] = useState(null);
  //CAC
  const [chartDataCAC, setChartDataCAC] = useState(null);
  const [chart24hrsDataCac, set24hrsDataCac] = useState(null);
  const [chartDataTatCACC, setDataTatCACC] = useState(null);
  // CSR
  const [chartDataCSR, setChartDataCSR] = useState(null);
  const [chartData18Csr, setChartData18Csr] = useState(null);
  const [chartData24Csr, setChartData24Csr] = useState(null);
  ////
  const { complaintButtonName, searchData, isToggle, setIstoggle } = useContext(FilterContext);
  // console.log("ComplaintButton Name", complaintButtonName);

  const [loading, setLoading] = useState(true);

  const transformComplaintData = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chart1",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  const transformComplaintDataT = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chart2",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  const transformComplaintDataTh = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chart3",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  const fetchData = async (searchData) => {
    try {
      setLoading(true);
      const apiData = await fetchcomplaintlt18Data(searchData);
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      const chartData = transformComplaintData(apiData);
      // console.log("Chart Data", chartData);
      setChartData(chartData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDatagt18 = async (searchData) => {
    // console.log("Search Data", searchData);

    try {
      setLoading(true);
      const apiDatagt = await fetchcomplaintlt24Data(searchData);
      if (!apiDatagt) {
        console.error("API response is empty or invalid:", apiDatagt);
        return;
      }
      const chartDatalt24 = transformComplaintDataT(apiDatagt);
      setChartlt24Data(chartDatalt24);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartlt24Data([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDatagt48 = async (searchData) => {
    try {
      setLoading(true);
      const apiDatagt48 = await complaintDataTat(searchData);
      if (!apiDatagt48) {
        console.error("API response is empty or invalid:", apiDatagt48);
        return;
      }
      const chartDatalt48 = transformComplaintDataTh(apiDatagt48);
      setChartgt48Data(chartDatalt48);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartgt48Data([]);
    } finally {
      setLoading(false);
    }
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////
  //Workshop complaints

  //Transform 1st//
  const transformComplaintltDataCAC = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "apiDataCAC",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  //Transform 2nd//

  const transformcomplaintlt24hrsDataCAC = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chart24hrsDataCac",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  // Trasform 3rd
  const transformComplaintDataTatCACC = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chartDataTatCACC",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  //1st fetch
  const fetch24hrsDataCAC = async (searchData) => {
    try {
      setLoading(true);
      const api24hrsDataCAC = await fetchcomplaintlt24hrsDataCAC(searchData);
      if (!api24hrsDataCAC) {
        console.error("API response is empty or invalid:", api24hrsDataCAC);
        return;
      }
      const chartDataCAC = transformcomplaintlt24hrsDataCAC(api24hrsDataCAC);
      setChartDataCAC(chartDataCAC);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartDataCAC([]);
    } finally {
      setLoading(false);
    }
  };

  //2nd fetch

  const fetchDataCAC = async (searchData) => {
    try {
      setLoading(true);
      const apiDataCAC = await fetchComplaintltDataCAC(searchData);
      if (!apiDataCAC) {
        console.error("API response is empty or invalid:", apiDataCAC);
        return;
      }
      const chart24hrsDataCac = transformComplaintltDataCAC(apiDataCAC);
      set24hrsDataCac(chart24hrsDataCac);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      set24hrsDataCac([]);
    } finally {
      setLoading(false);
    }
  };

  //   3rd Fetch

  const fetchDataTatCACC = async (searchData) => {
    try {
      setLoading(true);
      const apiDataTatCACC = await fetchComplaintDataTatCACC(searchData);
      if (!apiDataTatCACC) {
        console.error("API response is empty or invalid:", apiDataTatCACC);
        return;
      }
      const chartDataTatCACC = transformComplaintDataTatCACC(apiDataTatCACC);
      setDataTatCACC(chartDataTatCACC);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setDataTatCACC([]);
    } finally {
      setLoading(false);
    }
  };
  ///////////////////////////////////////////////////////////////////////////////////////////////

  ///CSR Complaints///

  // Transform 1

  const transformComplaintDataTatCSR = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chartDataCSR",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  // Transform 2nd
  const transformComplaintltDataCSR = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chartItDataCSR",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  // Transform 3rd

  const transformComplaintlt24hrsDataCSR = (data) => {
    const months = [...data.map((item) => item.month.toUpperCase())];
    const percentages = [
      ...data.map((item) => Math.ceil(item.percemtTransform)),
    ];
    const complaintsCount = data.reduce(
      (sum, item) => sum + item.percemtTransform,
      0
    );

    return [
      {
        id: "chart24hrsDataCSR",
        months,
        percentages,
        yAxisConfig: { min: 0, max: 80, interval: 20 },
        complaintsCount,
      },
    ];
  };

  // Fetch 1st

  const fetchDataTatCSR = async (searchData) => {
    try {
      setLoading(true);
      const apiDataTatCSR = await fetchComplaintDataTatCSR(searchData);
      if (!apiDataTatCSR) {
        console.error("API response is empty or invalid:", apiDataTatCSR);
        return;
      }
      const chartDataCSR = transformComplaintDataTatCSR(apiDataTatCSR);
      setChartDataCSR(chartDataCSR);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartDataCSR([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch 2nd

  const fetchItDataCSR = async (searchData) => {
    try {
      setLoading(true);
      const apiItDataCSR = await fetchComplaintltDataCSR(searchData);
      if (!apiItDataCSR) {
        console.error("API response is empty or invalid:", apiItDataCSR);
        return;
      }
      const chartData18Csr = transformComplaintltDataCSR(apiItDataCSR);
      setChartData18Csr(chartData18Csr);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartData18Csr([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch 3rd

  const fetchIt24hrsDataCSR = async (searchData) => {
    try {
      setLoading(true);
      const api24hrsDataCSR = await fetchComplaintlt24hrsDataCSR(searchData);
      if (!api24hrsDataCSR) {
        console.error("API response is empty or invalid:", api24hrsDataCSR);
        return;
      }
      const chartData24Csr = transformComplaintlt24hrsDataCSR(api24hrsDataCSR);
      setChartData24Csr(chartData24Csr);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setChartData24Csr([]);
    } finally {
      setLoading(false);
    }
  };

  ///////////////////////////////////////////////////////////////////
  useEffect(() => {
    const fetchDataIfNeeded = async () => {
      try {
        setLoading(true);
        if (initialLoad || isToggle) {
          await fetchData(searchData);
          await fetchDatagt18(searchData);
          await fetchDatagt48(searchData);
          // CAC
          await fetchDataCAC(searchData);
          await fetch24hrsDataCAC(searchData);
          await fetchDataTatCACC(searchData);
          // CSR
          await fetchDataTatCSR(searchData);
          await fetchItDataCSR(searchData);
          await fetchIt24hrsDataCSR(searchData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
        if (initialLoad) setInitialLoad(false); // Set initial load to false after first fetch
      }
    };

    fetchDataIfNeeded();
  }, [searchData, isToggle, initialLoad, setInitialLoad]);


  return (
    <div className=" grid grid-cols-1 lg:grid-cols-3 gap-2 justify-center justify-items-center">
      {complaintButtonName === "totalComplaints" && (
        <>
          {/* // Total Complaints */}
          {chartData && chartData.length > 0 && (
            <Card
              key={chartData[0].id}
              chartId={chartData[0].id}
              heading="TAT < 18 HRS"
              months={chartData[0].months}
              percentages={chartData[0].percentages}
              yAxisConfig={chartData[0].yAxisConfig}
              complaintsCount={chartData[0].complaintsCount}
            />
          )}

          {chartDatalt24 && chartDatalt24.length > 0 && (
            <Card
              key={chartDatalt24[0].id}
              chartId={chartDatalt24[0].id}
              heading="18 HRS > TAT < 24 HRS"
              months={chartDatalt24[0].months}
              percentages={chartDatalt24[0].percentages}
              yAxisConfig={chartDatalt24[0].yAxisConfig}
              complaintsCount={chartDatalt24[0].complaintsCount}
            />
          )}
          {chartDatalt48 && chartDatalt48.length > 0 && (
            <Card
              key={chartDatalt48[0].id}
              chartId={chartDatalt48[0].id}
              performance={chartDatalt48[0].performance}
              heading="24 HRS > TAT < 48 HRS"
              months={chartDatalt48[0].months}
              percentages={chartDatalt48[0].percentages}
              title={chartDatalt48[0].title}
              yAxisConfig={chartDatalt48[0].yAxisConfig}
            />
          )}
        </>
      )}

      {complaintButtonName === "workshopComplaints" && (
        <>
          {/* Workshop complaints */}

          {/* 1st graph */}
          {chart24hrsDataCac && chart24hrsDataCac.length > 0 && (
            <Card
              key={chart24hrsDataCac[0].id}
              chartId={chart24hrsDataCac[0].id}
              performance={chart24hrsDataCac[0].performance}
              heading=" TAT < 18 HRS "
              months={chart24hrsDataCac[0].months}
              percentages={chart24hrsDataCac[0].percentages}
              title={chart24hrsDataCac[0].title}
              yAxisConfig={chart24hrsDataCac[0].yAxisConfig}
            />
          )}

          {/* 2nd graph */}

          {chartDataCAC && chartDataCAC.length > 0 && (
            <Card
              key={chartDataCAC[0].id}
              chartId={chartDataCAC[0].id}
              performance={chartDataCAC[0].performance}
              heading="18 HRS > TAT < 24 HRS"
              months={chartDataCAC[0].months}
              percentages={chartDataCAC[0].percentages}
              title={chartDataCAC[0].title}
              yAxisConfig={chartDataCAC[0].yAxisConfig}
            />
          )}

          {/* 3rd graph */}
          {chartDataTatCACC && chartDataTatCACC.length > 0 && (
            <Card
              key={chartDataTatCACC[0].id}
              chartId={chartDataTatCACC[0].id}
              performance={chartDataTatCACC[0].performance}
              heading="24 HRS > TAT < 48 HRS"
              months={chartDataTatCACC[0].months}
              percentages={chartDataTatCACC[0].percentages}
              title={chartDataTatCACC[0].title}
              yAxisConfig={chart24hrsDataCac[0].yAxisConfig}
            />
          )}
        </>
      )}

      {complaintButtonName === "enRouteBreakdownComplaints" && (
        <>
          {/* CSR */}
          {/* 1st */}
          {chartData18Csr && chartData18Csr.length > 0 && (
            <Card
              key={chartData18Csr[0].id}
              chartId={chartData18Csr[0].id}
              performance={chartData18Csr[0].performance}
              heading=" TAT < 18 HRS"
              months={chartData18Csr[0].months}
              percentages={chartData18Csr[0].percentages}
              title={chartData18Csr[0].title}
              yAxisConfig={chartData18Csr[0].yAxisConfig}
            />
          )}

          {/* 2nd */}
          {chartData24Csr && chartData24Csr.length > 0 && (
            <Card
              key={chartData24Csr[0].id}
              chartId={chartData24Csr[0].id}
              performance={chartData24Csr[0].performance}
              heading="18 HRS > TAT < 24 HRS"
              months={chartData24Csr[0].months}
              percentages={chartData24Csr[0].percentages}
              title={chartData24Csr[0].title}
              yAxisConfig={chartData24Csr[0].yAxisConfig}
            />
          )}
          {/* 3rd */}
          {chartDataCSR && chartDataCSR.length > 0 && (
            <Card
              key={chartDataCSR[0].id}
              chartId={chartDataCSR[0].id}
              performance={chartDataCSR[0].performance}
              heading="24 HRS > TAT < 48 HRS"
              months={chartDataCSR[0].months}
              percentages={chartDataCSR[0].percentages}
              title={chartDataCSR[0].title}
              yAxisConfig={chartDataCSR[0].yAxisConfig}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Graphview;
